import { render, staticRenderFns } from "./ShowNotificationDataModal.vue?vue&type=template&id=2a071cd7&scoped=true&"
import script from "./ShowNotificationDataModal.vue?vue&type=script&lang=js&"
export * from "./ShowNotificationDataModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a071cd7",
  null
  
)

export default component.exports